/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const FilterLogic = zod.union([zod.literal(0),zod.literal(1)]);

export type FilterLogic = zod.input<typeof FilterLogic>;
export type FilterLogicOutput = zod.output<typeof FilterLogic>;
